import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import Chatbot from "./components/chatbot/Chatbot";

function App() {
  return (
    <div>
      <Main />
      <Chatbot />
    </div>
  );
}

export default App;
